export default __webpack_public_path__ + "static/media/file.5960143b.svg";